export const pagetitle = {
    DFS: '24小时礼宾服务',
    Hotel: '酒店权益',
    Enquiry: '在线预订',
    Detail: '权益详情',
    Search: '搜索'
}

export const home = {
    recommend: '推荐服务',
    benefits: '礼遇及福利',
    benefitsInfo: '探索我们的礼宾服务、旅行和生活方式体验、专享权益以及礼宾计划详情',
    contact: '想了解更多?',
    hotline: '热线',
    livechat: '在线客服',
    more: '更多',
    welcometitle: '欢迎使用24小时精致生活礼宾服务',
    welcomedetail: '在此，高级会员可尽享非凡的个性化服务，包括酒店预订、餐厅推荐以及更多奢尚惊喜。',
    welcomenotice: '本服务是由我们的合作伙伴Aspire提供。所收集的相关信息仅限用于提供私人礼宾服务、提升服务品质以及内部培训。',
    selectnumber: '请选择电话号码',
    selectnumbertips:'我们的客户服务团队可以根据您选择的地点，为您提供英语、普通话、粤语或日语服务。',
    selectnumbernotice:'*根据您所选地点的服务提供商，可能会收取本地/海外费用。'
}

export const service = {
    title: '礼遇优待',
    list1: '解锁大使级会员专享权益',
    list2: '免费升级酒店房型及早餐',
    list3: '可享提前入住及延迟退房服务，度假村及水疗服务',
    tips: '具体以酒店说明为准',
    more: '展开',
    less: '收起'
}

export const toolbar = {
    hotel: '酒店',
    dinning: '餐饮',
    travel: '旅行',
    entertainment: '娱乐',
    club: '私人会所',
    education: '教育',
    golf: '高尔夫球',
    business: '商务',
    reservation: '酒店预订'
}

export const category = {
    hotel: '酒店',
    dinning: '餐饮',
    travel: '机场或旅行服务',
    entertainment: '娱乐',
    club: '私人会所',
    education: '教育',
    golf: '高尔夫球',
    business: '商务',
}

export const info = {
    hotel: '通过我们的礼宾服务安排下一趟旅程，入住奢华酒店可享免费房型升级、免费早餐以及其他尊贵VIP服务。',
    dinning: '我们的礼宾团队将为您提供热门餐厅预订服务，以便您体验非凡环球美馔及美酒。',
    travel: '旅行',
    entertainment: '娱乐',
    club: '私人会所',
    education: '教育',
    golf: '高尔夫',
    business: '商务',
}

export const city = {
    hotcity: '热门城市',
    shanghai: '上海',
    osaka: '大阪',
    singapore: '新加坡',
    hiangmai: '清迈',
    paris: '巴黎',
    london: '伦敦',
    newyork: '纽约',
    sydney: '悉尼'
}

export const hotel = {
    title: '酒店预订',
    more: '查看更多',
    location: '地点',
    searchcity: '搜索城市',
    pickdate: '选择日期',
    travelernumber: '入住人数',
    childnumber: '儿童人数',
    nightSin: '晚',
    nightPlu: '晚',
    room: '房间',
    roomSin: '间',
    roomPlu: '间',
    adults: '成人人数',
    adultSin: '成人',
    adultPlu: '成人',
    children: '儿童人数',
    childSin: '儿童',
    childPlu: '儿童',
    travelerSin: '位',
    travelerPlu: '位',
    age: '0-16岁',
    group: '酒店品牌',
    all: '全部',
    hotcity: '热门目的地',
    brandfilter: '酒店品牌',
    pricefilter: '价格',
    privilege: 'VIP 特权',
    discount: '已享折扣',
    from: '最低',
    full: '不适用',
    empty: '暂无信息',
    noroomdata: '您选择的日期当前暂无房型',
    selectroom:'选择房型',
    roomtype: '房型',
    facility: '设施及服务',
    policy: '取消政策',
    noncancel: '不可取消',
    deadline: '前可取消，超过最晚取消时间取消，酒店将有权扣除1晚的房费',
    searchtip: '如果未能找到您想要的酒店，请联系客服'
}

export const buttonTxt = {
    done: '确认',
    cancel: '取消',
    search: '搜索',
    selectroom: '请选择房型',
    bookroom: '立即预订',
    confirmbook: '确认',
    myorder: '查看订单',
    gohome: '返回首页',
    reserve: '立即预约',
    enquire: '预约咨询',
    submitEnquire: '预约咨询',
    accept: '接受',
    change:' 返回修改',
    cancelOrder: '取消订单',
    confirm: '确认',
    notcancel: '暂不取消'
}

export const toast = {
    pickerdate: '至少一晚',
    errorEmail: '邮箱格式错误',
    errorName: '英文名或拼音',
    unLogin: '用户未登录',
    nologin:'缺少用户信息，请重新登录',
    cancelTitle: '确认取消订单?',
    cancelTip: '请确认是否取消该订单?',
    cancelsuccess:'取消成功',
    cancelfailed:'取消失败',
    requesterror:'预订失败，请稍后再试'
}

export const form = {
    searchcity: '搜索城市',
    searchkey: '请输入关键词',
    roomnumber: '房间数',
    peopleNumber: '入住人數',
    checkin: '入住日期',
    checkout: '离店日期',
    cost: '总计',
    price: '房价明细',
    other: '其他',
    tax: '税款及服务费',
    information: '联络信息',
    name: '住客姓名',
    gender: '尊称',
    male: '先生',
    female: '女士',
    firstname: '名',
    lastname: '姓',
    contactmobile: '联系电话',
    areacode: '区号',
    mobile: '手机号',
    contactemail: '联系邮箱',
    emailaddress: '邮箱地址',
    contacttime: '期望联系时间',
    dateperiod: '联系日期段',
    timeperiod: '联系时间段',
    timedetail: '客服人员将于您期望的时间联系以确认预订信息',
    fqt: '常旅行计划码',
    fqttip: '请于入住酒店时确认',
    codenumber: '常旅行计划码',
    special: '特殊要求',
    specialtip: '请填写特殊要求，最多200字',
    payment: '支付明细',
    paymentmethod: '支付方式',
    cardtype: '支付卡类型',
    cardnumber: '卡号',
    expiration: '有效期至',
    month: '月',
    year: '年',
    creditcard:'信用卡',
    success: '预订成功',
    enquiresent: '您的意向已提交',
    successnotice: '您已成功提交，我们将尽快联系您',
    contactdetail: '如有关于已预订服务的更新，我们将通过电子邮件、短信或电话联系您。',
    contactmethod: '期望联系方式',
    phonecall: '电话',
    email: '邮箱',
    anyday: '任意日期',
    weekday: '工作日',
    weekend: '周末',
    anytime: '任意时间',
    morning: '上午',
    afternoon: '下午',
    evening: '晚上',
    additional: '其他需求',
    additionaltip: '如有任何特殊要求或备注，请留言说明。',
    attendeenumber: '同行人数',
    attendee: '同行人',
    reservedate: '预订日期',
    time: '请至少提前24小时预订',
    call: '致电',
    isrequired:'不能为空'
}

export const order = {
    checkin: '入住',
    checkout: '退房',
    total: '共计',
    reservation: '订单日期',
    success: '预订成功',
    cancel: '已取消',
    name: '姓名',
    phone: '手机号',
    email: '邮箱地址',
    useDate: '预订日期',
    special: '其他需求'
}

export const other = {
    hotcity: '热门城市',
    address: '地址',
    summary: '介绍',
    details: '详情',
    clause: '条款',
    service: '咨询服务',
    reservation: '预订查询',
    terms: '条款&条件',
    termsdetail: '<p>1. 某些房型不适用于客房升等或特别优惠。</p><p>2. 房型如有变化酒店拥有最终解释权。</p><p>3. 并不是所有参与酒店都提供客房内Wi-Fi礼遇。敬请致电客户服务热线了解更多详情。</p><p>4. 酒店体验礼遇根据酒店而不同，敬请致电客户服务热线了解更多详情。</p>',
    domestic:'中国'
}

export const telephone = {
    China: '中国',
    Macao: '澳门',
    Japan: '日本',
    HongKong: '香港',
    Guam: '美国',
    Australia: '澳大利亚',
    France: '法国'
}


// WEBPACK FOOTER //
// ./src/language/zh_cn.js